import { useScommessaStatus } from 'features/sport/hooks';
import { useCallback, useRef, useState } from 'react';
import { domContains } from 'utility/functions';
import { useIsomorphicLayoutEffect } from 'hooks';
import { EVENTS_DELAY, ScommesseFallbackHookProps, ScommesseFallbackHookType } from '.';
import { isServerSide } from 'utility/constant';

export const useScommesseFallback = ({ container, isReady }: ScommesseFallbackHookProps): ScommesseFallbackHookType => {
  const tmrRef = useRef<NodeJS.Timeout | undefined>();
  const [isEmpty, setEmpty] = useState(true);
  const { status, isIdle, isError, isLoading, isUninitialized } = useScommessaStatus();

  const doCount = useCallback(() => {
    if (tmrRef.current) {
      clearTimeout(tmrRef.current);
    }
    let haBet = domContains(container, ["[data-kind='betting-option']", "[class*='ScommesseAccordion_item']"]);
    tmrRef.current = setTimeout(doCount, EVENTS_DELAY);
    if (haBet === isEmpty) {
      setEmpty(haBet ? false : true);
    }
  }, [container, isReady]);

  useIsomorphicLayoutEffect(() => {
    if (isServerSide) return;
    doCount();
  }, [status, isReady, doCount]);

  return {
    showEmpty: isEmpty && (isError || isIdle),
    showLoader: isEmpty && (isLoading || isUninitialized),
  };
};
